import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
export function Brand({ light = false }: { light?: boolean }) {
  return (
    <Link to="/" className="brand" aria-label="Foxet home">
      <img
        src={light ? '/logo-white.svg' : '/logo.svg'}
        alt="Foxet.ai"
        width="158"
        height="38"
      />
    </Link>
  );
}
export function ActionLink({
  href,
  children,
  secondary = false,
  external = false,
  accent = false,
}: {
  href: string;
  children: ReactNode;
  secondary?: boolean;
  external?: boolean;
  accent?: boolean;
}) {
  const className = `button ${secondary ? 'button-secondary' : accent ? 'button-primary' : 'button-dark'}`;
  return href.startsWith('http') || external ? (
    <a
      className={className}
      href={href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
    >
      {children}
      {external ? (
        <ArrowUpRight size={17} aria-hidden="true" />
      ) : (
        <ArrowRight size={17} aria-hidden="true" />
      )}
    </a>
  ) : (
    <Link className={className} to={href}>
      {children}
      <ArrowRight size={17} aria-hidden="true" />
    </Link>
  );
}
export function SectionHeading({
  number,
  label,
  title,
  children,
}: {
  number: string;
  label: string;
  title: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="section-heading">
      <p className="eyebrow">
        <span>{number}</span>
        {label}
      </p>
      <h2>{title}</h2>
      {children && <p className="section-description">{children}</p>}
    </div>
  );
}
